import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-generic-message-modal',
    templateUrl: './generic-message-modal.component.html',
    styleUrls: ['./generic-message-modal.component.scss'],
    standalone: false
})
export class GenericMessageModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
